import { MenuState } from '@features/main/interfaces/main.interfaces';
import useAuth from '@hooks/auth.hook';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import UserInfo from '../UserInfo';
import useMenuPopUpStyles from './MenuPopUp.styles';
import { motion } from 'framer-motion';
import { handlePopUpClick } from './MenuPopUp.handlers';
import { ACCOUNT_SETTINGS_PATH } from '@constants/paths.constant';

interface Props {
	menuState: MenuState;
	open: boolean;
}

const rootVariants = {
	open: {
		opacity: 1,
	},
	closed: {
		opacity: 0,
	},
};

const MenuPopUp: React.FC<Props> = ({ menuState, open }) => {
	const classes = useMenuPopUpStyles();
	const { logout } = useAuth();

	return (
		<motion.div
			className={clsx(classes.root, {
				[classes.rootDisabled]: !open,
				[classes.rootActive]: open,
			})}
			animate={open ? 'open' : 'closed'}
			id="menu_popup_container"
			onClick={handlePopUpClick}
			transition={{ duration: 0.2 }}
			variants={rootVariants}
		>
			<div id="menu_popup_userinfo_container">
				<UserInfo
					id="menu_popup_userinfo_content"
					menuState={menuState}
					popUpState={open}
				/>
			</div>
			<ul className={classes.navigation} id="menu_popup_navigation_container">
				<li className={classes.navigationItem} id="menu_popup_settings">
					<Link to={ACCOUNT_SETTINGS_PATH}>Configuración de la cuenta</Link>
				</li>
				<li className={classes.navigationItem} id="menu_popup_logout">
					<a href="/" onClick={(event) => void logout(event)}>
						Salir de la cuenta
					</a>
				</li>
			</ul>
		</motion.div>
	);
};

export default MenuPopUp;
